<template>
  <div class="info-region-container" style="height: 100vh; width: 100%" v-allow="'0904'">
    <div class="all-content-container">
      <div class="info-title-container container-user">
        <div class="title_muen">
          <h4>组织机构</h4>
          <el-button v-allow="'090401'" type="primary" class="adduser" @click="addOrganization">添加</el-button>
        </div>
      </div>
      <div class="info-content-container">
        <div class="table_content" style="margin-left: 20px">
          <div class="info-content-container">
            <el-table :highlight-current-row="true" :indent="30" :data="tableData" style="width: 100%" row-key="id"
              max-height="500" :header-cell-style="{ background: '#f4f5f7' }"
              :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
              <el-table-column align="center" label="序号" width="95">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="name" align="center" label="机构名称"></el-table-column>
              <el-table-column prop="describes" align="center" label="机构描述"></el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <el-button v-allow="'090402'" @click="handleClicksysDepart(scope.row.id, 'edit')" type="text"
                    size="small">编辑</el-button>
                  <el-button v-allow="'090403'" type="text" size="small" @click="delDepart(scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

            <div class="pagination-container"></div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="centerDialogVisible" width="600px" center :before-close="resetForm">
      <div>
        <el-form :model="dialogformInline" :rules="dialogRules" ref="dialogformInline" style="margin-left: 60px">
          <el-row>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <el-form-item label="上级机构：" prop="departId" label-width="100px">
                  <el-cascader class="el-dailog_width" @change="changeTreeItem" :show-all-levels="false"
                    v-model="dialogformInline.departId" :options="departList" :props="optionProps" clearable
                    placeholder="请选择上级机构"></el-cascader>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <el-form-item label="机构名称：" label-width="100px" prop="name">
                  <el-input class="el-dailog_width" v-model="dialogformInline.name" maxlength="20"
                    placeholder="请输入机构名称"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="grid-content bg-purple-dark">
                <el-form-item label="机构描述：" prop="describes" label-width="100px">
                  <el-input v-model="dialogformInline.describes" class="el-dailog_width" maxlength="20"
                    placeholder="请输入机构描述"></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetForm">取 消</el-button>
        <el-button type="primary" @click="submitForm('dialogformInline')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "organization",
  data() {
    return {
      dialogTitle: "", //弹框标题
      centerDialogVisible: false,
      pagesize: 8,
      currentPage: 1,
      total: 100,
      id: 1,
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        expandTrigger: "hover",
        checkStrictly: true,
      },
      formInline: {
        name: "",
      },
      modelNoListData: [
        {
          label: "全部",
          id: -1,
        },
        {
          label: "管理员",
          id: 0,
        },
        {
          label: "普通用户",
          id: 1,
        },
      ],
      organizationList: [
        {
          label: "全部",
          id: -1,
        },
        {
          label: "武汉",
          id: 0,
        },
        {
          label: "上海",
          id: 1,
        },
      ],
      departId: "",
      dialogformInline: {
        parentId: "", // 组织机构
        name: "", //组织机构名称
        describes: "", // 描述
        departId: "",
      },
      dialogRules: {
        describes: [
          { required: true, message: "请输入机构描述", trigger: "change" },
        ],
        name: [
          { required: true, message: "请输入机构名称", trigger: "change" },
        ],
        departId: [
          { required: true, message: "请选择上级机构", trigger: "change" },
        ],
      },
      tableData: [],
      departList: [],
    };
  },

  computed: {},
  created() {
    this.init();
  },
  mounted() { },
  methods: {
    init() {
      this.getDepartList2();
      this.getsysDepartMessageList(); //列表信息
    },
    changeTreeItem(val) {
      this.dialogformInline.parentId = val[val.length - 1];
      this.formInline.organization = val[val.length - 1];
    },
    //usrReset
    usrReset() {
      this.formInline.name = "";
    },

    //查询组织机构
    getsysDepartMessageList() {
      this.$api.system
        .getsysDepartMessageList(
          this.id,
          this.currentPage, //第几页，默认1
          this.pagesize //默认展示多少条，默认10
        )
        .then((res) => {
          if (res.code == 200) {
            this.total = res.count;
            let tableData = res.data;
            for (let i of tableData) {
              i.id === 0 ? (i.id = -1) : i.id;
            }
            this.tableData = tableData;
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //查询
    sysDepartKey() {
      this.getsysDepartMessageList();
    },
    //分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getsysDepartMessageList();
    },
    //删除按钮
    delDepart(id) {
      this.$confirm("是否删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.system.delfun(`/pc/sysDepart/delDepart`, id).then((res) => {
            if (res.code == 200) {
              this.getsysDepartMessageList(); //列表信息
              this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
            }
          });
        })
        .catch((err) => {
          this.$message.info("已取消删除");
        });
    },
    // 添加机构
    addOrganization() {
      this.dialogformInline.id = undefined;
      this.dialogTitle = "添加机构";
      (this.dialogformInline = {
        parentId: "", // 组织机构
        name: "", //组织机构名称
        describes: "", // 描述
        departId: "",
      }),
        (this.centerDialogVisible = true);
      this.getDepartList2(); //机构
    },
    empty() {
      //清空表单

      this.dialogformInline.parentId = ""; //清空
      this.dialogformInline.name = ""; //清空
      this.dialogformInline.describes = ""; //清空
    },

    submitForm(formName) {
      // 提交表单
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if ((this.dialogTitle = "添加机构")) {
            //添加机构
            this.newSaveDepart();
          } else if ((this.dialogTitle = "编辑机构")) {
            //编辑添加机构
            this.newSaveDepart();
          }
        } else {
          return false;
        }
      });
    },
    cancellation() {
      this.empty();
      this.$forceUpdate();
      this.centerDialogVisible = false;
    },
    // 列表编辑
    handleClicksysDepart(id) {
      this.dialogTitle = "编辑";
      this.centerDialogVisible = true;
      this.getMessageEdit(id); //
      this.getDepartList2(); //机构
    },
    // 添加机构接口
    newSaveDepart() {
      this.$api.system
        .newSaveDepart(
          this.dialogformInline.name, //机构名称
          this.dialogformInline.parentId, //上级机构（无上级为0）
          this.dialogformInline.describes, //	机构描述
          this.dialogformInline.id,
          this.dialogformInline.remark //备注
        )
        .then((res) => {
          if (res.code == 200) {
            this.getsysDepartMessageList(); //列表信息
            this.centerDialogVisible = false;
            this.$message({
              type: "success",
              message: res.msg,
            });
            //this.empty();
          } else {
            this.centerDialogVisible = false;
          }
          this.resetForm();
        })
        .catch((err) => {
          this.$message.info(err);
        });
    },
    //
    //组织机构
    getDepartList2() {
      this.$api.system
        .getDepartList(
          0 //0为中国
        )
        .then((res) => {
          if (res.code == 200) {
            this.departList = res.data; //组织机构
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.info(err);
        });
    },
    //编辑是获取信息getMessageEdit
    getMessageEdit(id) {
      this.$api.system
        .getMessageEdit(id)
        .then((res) => {
          if (res.code == 200) {
            this.departList.forEach((value) => {
              if ((value.parentId = res.data.parentId)) {
                //this.dialogformInline.parentId = value.name;
                this.dialogformInline.parentId = value.parentId;
                this.dialogformInline.departId = value.parentId;
              }
            });
            this.dialogformInline.name = res.data.name; //组织机构名称
            this.dialogformInline.describes = res.data.describes; // 描述
            this.dialogformInline.id = res.data.id; // 描述
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.info(err);
        });
    },
    resetForm() {
      this.centerDialogVisible = false;
      this.$refs["dialogformInline"].resetFields();
    },
  },
};
</script>
<style scoped lang="scss"></style>